import React from "react";
import HTML from "../assets/html-5.png";
import CSS from "../assets/css-3.png";
import Express from "../assets/Express.png";
import Javascript from "../assets/Javascript.png";
import Node from "../assets/nodejs.png";
import PostgreSQL from "../assets/PostgreSQL.png";
import ReactI from "../assets/React.png";
import Redux from "../assets/Redux.png";
import Sequelize from "../assets/Sequelize.png";
import Github from "../assets/Github.png";
import Tailwind from "../assets/Tailwind.png";

const Skills = () => {
  const skills = [
    { name: "HTML5", icon: HTML, level: 90, color: "#f97316" }, // orange-500
    { name: "CSS3", icon: CSS, level: 90, color: "#3b82f6" }, // blue-500
    { name: "JavaScript", icon: Javascript, level: 85, color: "#eab308" }, // yellow-500
    { name: "React", icon: ReactI, level: 90, color: "#60a5fa" }, // blue-400
    { name: "Node.js", icon: Node, level: 80, color: "#22c55e" }, // green-500
    { name: "Express", icon: Express, level: 80, color: "#475569" }, // slate-600
    { name: "PostgreSQL", icon: PostgreSQL, level: 75, color: "#2563eb" }, // blue-600
    { name: "Redux", icon: Redux, level: 75, color: "#9333ea" }, // purple-600
    { name: "Sequelize", icon: Sequelize, level: 70, color: "#1e40af" }, // blue-800
    { name: "GitHub", icon: Github, level: 85, color: "#1e293b" }, // slate-800
    { name: "Tailwind CSS", icon: Tailwind, level: 90, color: "#14b8a6" }, // teal-500
  ];

  const tools = [
    "JWT Authentication",
    "AFIP Web Services",
    "Stripe Payments",
    "RESTful APIs",
    "Scrum/Agile",
    "Git/GitHub",
  ];

  return (
    <div
      name="skills"
      className="w-full min-h-screen bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-200 py-20 lg:py-24 transition-colors duration-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            Tecnologías
          </h2>
          <div className="w-24 h-1 bg-blue-600 dark:bg-blue-500 mx-auto mb-6"></div>
          <p className="text-lg sm:text-xl text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
            Stack tecnológico que domino y utilizo en mis proyectos
          </p>
        </div>

        {/* Grid de habilidades */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-6 mb-12">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="bg-slate-50 dark:bg-slate-800 p-6 rounded-xl border border-slate-200 dark:border-slate-700 hover:border-blue-300 dark:hover:border-blue-500 hover:shadow-xl dark:hover:shadow-blue-500/20 transition-all duration-300 group"
            >
              <div className="flex flex-col items-center">
                <img
                  className="w-16 h-16 mb-4 group-hover:scale-110 transition-transform duration-300"
                  src={skill.icon}
                  alt={`${skill.name} icon`}
                />
                <p className="font-semibold text-slate-900 dark:text-white text-center mb-3 text-sm sm:text-base">
                  {skill.name}
                </p>
                <div className="w-full bg-slate-200 dark:bg-slate-700 rounded-full h-2">
                  <div
                    className="h-2 rounded-full transition-all duration-500"
                    style={{
                      width: `${skill.level}%`,
                      backgroundColor: skill.color,
                    }}
                  ></div>
                </div>
                <span className="text-xs text-slate-600 dark:text-slate-400 mt-2">
                  {skill.level}%
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Sección de herramientas y servicios */}
        <div className="mt-16">
          <h3 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white mb-8 text-center">
            Herramientas y Servicios
          </h3>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
            {tools.map((tool, index) => (
              <span
                key={index}
                className="bg-gradient-to-r from-blue-600 to-blue-700 dark:from-blue-500 dark:to-blue-600 text-white px-5 py-3 rounded-lg font-semibold shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300"
              >
                {tool}
              </span>
            ))}
          </div>
        </div>

        {/* Sección de experiencia adicional */}
        <div className="mt-16 bg-gradient-to-br from-slate-50 to-blue-50 dark:from-slate-800 dark:to-slate-700 rounded-2xl p-8 border border-slate-200 dark:border-slate-600">
          <h3 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white mb-6 text-center">
            Experiencia Adicional
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="bg-blue-600 dark:bg-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h4 className="font-bold text-slate-900 dark:text-white mb-2">
                Metodologías Ágiles
              </h4>
              <p className="text-slate-600 dark:text-slate-300 text-sm">
                Experiencia con Scrum y desarrollo iterativo
              </p>
            </div>
            <div className="text-center">
              <div className="bg-blue-600 dark:bg-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
                  />
                </svg>
              </div>
              <h4 className="font-bold text-slate-900 dark:text-white mb-2">
                DevOps & Deployment
              </h4>
              <p className="text-slate-600 dark:text-slate-300 text-sm">
                VPS con Ubuntu, PM2, Nginx - Todos mis proyectos en producción
              </p>
            </div>
            <div className="text-center">
              <div className="bg-blue-600 dark:bg-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              </div>
              <h4 className="font-bold text-slate-900 dark:text-white mb-2">
                Trabajo en Equipo
              </h4>
              <p className="text-slate-600 dark:text-slate-300 text-sm">
                Colaboración efectiva y comunicación constante
              </p>
            </div>
            <div className="text-center">
              <div className="bg-blue-600 dark:bg-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h4 className="font-bold text-slate-900 dark:text-white mb-2">
                Aprendizaje Continuo
              </h4>
              <p className="text-slate-600 dark:text-slate-300 text-sm">
                Siempre actualizado con las últimas tecnologías
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
